<div class="headline">
  <nav class="navbar container">
    <ul class="navbar-nav">
      <li class="nav-item"
        *ngIf="isConnected()">
        <a class="nav-link"
          routerLink="/accueil"
          routerLinkActive="active"
          id="menu-left"
          [routerLinkActiveOptions]="{ exact: true }">
          {{'sigt.global.menu.accueil' | translate}}
        </a>
      </li>

      <li class="nav-item"
        *ngIf="isConnected() && (isNotInBaseRole() || isIntranet())">
        <a class="nav-link"
          routerLink="/carte"
          routerLinkActive="active">
          {{'sigt.global.menu.carte' | translate}}
        </a>
      </li>

      <li class="nav-item"
        *ngIf="isConnected() && !isIntranet() && isRegistered()">
        <a class="nav-link"
          routerLink="/utilisateur/mes-informations"
          routerLinkActive="active">
          {{'sigt.global.menu.monDossier' | translate}}
        </a>
      </li>

      <li class="nav-item"
        *ngIf="isConnected() && isPilote() && isIntranet()">
        <a class="nav-link"
          routerLink="/pilotage"
          routerLinkActive="active">
          {{'sigt.global.menu.pilotage' | translate}}
        </a>
      </li>
    </ul>

    <div class="user-panel">
      <button *ngIf="!isConnected()"
        type="button"
        class="btn-connexion"
        (click)="connecter()">
        {{'accueil.inscription.bouton_connexion' | translate}}
      </button>

      <button *ngIf="isConnected()"
        type="button"
        class="btn-connexion"
        (click)="deconnecter()">
        {{'accueil.inscription.bouton_deconnexion' | translate}}
      </button>
    </div>
  </nav>
</div>